import script from "./cardapio-gelateria.vue?vue&type=script&setup=true&lang=js"
export * from "./cardapio-gelateria.vue?vue&type=script&setup=true&lang=js"

import "./cardapio-gelateria.vue?vue&type=style&index=0&id=cd2e323e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd2e323e"]])

export default __exports__